import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import { AuthenticationService } from "../../services/authentication.service";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { environment } from '../../../environments/environment';
import jwtDecode from 'jwt-decode';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public email: string;
  public password: string;
  public rememberMe: boolean = true;
  public loginFailed: boolean = false;
  public errorMessage: string;

  constructor(private _authenticationService: AuthenticationService, private _router: Router, private _toastService: ToastrService, private _ngxUiLoaderService: NgxUiLoaderService) { }

  ngOnInit() {
  }

  public async login(): Promise<void> {
    this._ngxUiLoaderService.start();
    this.loginFailed = false;

    try {
      const result = await this._authenticationService.login(this.email, this.password, this.rememberMe);
      this._ngxUiLoaderService.stop();

      if (result.success && result.requires2FA) {
        await this._router.navigate(['account/otp']);
        return;
      }

      if (result.success) {
        const token = this._authenticationService.getToken(); // <-- implement this getter
        const decoded: any = jwtDecode(token);

        if (decoded.IsPasswordExpired === 'True') {
          this._toastService.warning('Your password has expired. Please reset it.');
          await this._router.navigate(['/reset-password'], {
            queryParams: { expired: true }
          });
        } else {
          await this._router.navigate(['']); // redirect to dashboard
        }
        return;
      }

      this.loginFailed = true;
      this.errorMessage = result.message || 'Invalid credentials.';

    } catch (error) {
      this.loginFailed = true;
      this.errorMessage = 'Unexpected error occurred.';
    }

    this._ngxUiLoaderService.stop();
  }


  public get isUAT(): boolean {
    return !environment.production;
  }

}
